import { Dialog, Portal, IconButton } from '@welbe/design-system';
import { FiX } from 'react-icons/fi';
import { UploadComponent } from './UploadComponent';

type ModalUploadEmployeeProps = {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
};

const rows: string[][] = [
	[
		'Membresia',
		'Nombre del colaborador',
		'Apellido paterno',
		'Apellido Materno',
		'Checkup requerido',
		'CURP',
		'E-mail alternativo',
		'Sucursal',
		'Numero do empleado',
		'Motivo de error',
	],
];

export const ModalUploadEmployee = ({
	open,
	onClose,
	onSuccess,
}: ModalUploadEmployeeProps) => {
	return (
		<Dialog.Root
			open={open}
			onOpenChange={(state: { open: boolean }) => !state.open && onClose()}
			color="#64778F"
			closeOnEscape={false}
			closeOnInteractOutside={false}
		>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content backgroundColor="#FAFCFD" animation="slideIn">
						<UploadComponent
							type="addEmployees"
							rows={rows}
							onClose={onClose}
							onSuccess={onSuccess}
						/>
						<Dialog.CloseTrigger asChild>
							<IconButton size="xs" variant="ghost">
								<FiX />
							</IconButton>
						</Dialog.CloseTrigger>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
